// extracted by mini-css-extract-plugin
module.exports = {"file-preview__label":"FilePreview_file-preview__label__394dF","file-preview__remove":"FilePreview_file-preview__remove__20L4w"};